import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { Button, Form, FormControl } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API, get, metaTitle } from "../../../config";
import { formatName } from "../../common/Misc";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import { debounce } from "lodash";
import UserActionButton from "../../Users/components/UserActionButton";
import AddUser from "../../Users/AddUser";
// import { getClientDetail } from "./components/ClientHelper";
import TitleBar from "../../common/TitleBar";

const UsersForClient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [usersList, setUsersList] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || 10);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const params = useParams();
  const clientID = params?.client_id;

  const [showUser, setShowUser] = useState(false);

  const clientId = localStorage.getItem("sme-clientId") === null ? clientID : localStorage.getItem("sme-clientId");

  const fetchUsers = useCallback(async () => {
    try {
      setUserLoading(true);
      const { data } = await get(
        `${API.GET_CLIENT_USER}?client_id=${clientId ? clientId : ""
        }&limit=${limit ? limit : 10}&page=${page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}`
      );
      setUserLoading(false);
      setLimit(data?.data?.per_page);
      setPage(data?.data?.current_page);
      setTotal(data?.data?.total);
      setFrom(data?.data?.from);
      setTo(data?.data?.to);
      const usersList = data?.data?.data;
      setUsersList(usersList);
      return 0;
    } catch (e) {
      const { data } = e;
      setUserLoading(false);
      setUsersList([]);
      toast.error(
        data &&
        data.errors &&
        data.errors.myna_error &&
        data.errors.myna_error[0]
      );
    }
  }, [clientId,limit, page, searchParam, sortOrder, sortField]);

  const userModal = () => {
    fetchUsers();
  };

  const usersGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: usersList[i]?.id,
        user_id: usersList[i]?.client_user?.user_id ? usersList[i]?.client_user?.user_id : "",
        name: formatName(usersList[i]?.first_name, usersList[i]?.last_name),
        email: usersList[i]?.email ? usersList[i]?.email : "-",
        phone: usersList[i]?.phone ? usersList[i]?.phone : "-",
        mobile: usersList[i]?.mobile ? usersList[i]?.mobile : "-",
        action: (
          <UserActionButton id={usersList[i]?.id} userModal={userModal} clientId={clientId}/>
        ),
      });
    }
    return items;
  };

  const usersData = usersGenerator(usersList?.length);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      // sort: true,
    },
    {
      dataField: "mobile",
      text: "Mobile",
      // sort: true,
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    navigate(
      `?limit=${limit ? limit : 10}&page=${page ? page : 1}&search=${
        searchParam ? searchParam : ""
      }&sort_column=${sortField ? sortField : ""}&sort_order=${
        sortOrder ? sortOrder : ""
      }`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  useEffect(() => {
    window.document.title = `${metaTitle} | Client Users`
  },[])

  //eslint-disable-next-line
  const debouncedSave = useCallback(
    debounce(nextValue => {
          setSearchParam(nextValue)
          setPage(1)
        }, 300),
    [], 
  );
  
  const handleSearchChange = event => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    if(nextValue?.length >= 2 || nextValue?.length === 0){
      debouncedSave(nextValue);
    }
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  useEffect(() => {
    if(clientId){
      fetchUsers();
    }
  }, [fetchUsers, clientId]);

  const toggleUserModal = () => {
    showUser && userModal();
    setShowUser(!showUser);
  };

  return (
    <>
      {" "}
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <TitleBar
              label={"Users"}
              businessNameData={false}
              globalSearch={false}
            /> 
            <div className="content-details">
              <div className="table-top-btn">
                <div className="search-section">
                  <Form>
                    <FormControl
                      onChange={handleSearchChange}
                      type="text"
                      value={searchParamData}
                      placeholder="Search User"
                    />
                    {searchParamData 
                    ? <Button className="btn-close" onClick={() => {
                      setSearchParamData("")
                      setSearchParam("")
                    }}
                    >x</Button> 
                    : <Button className="fa fa-search">Search</Button>}
                  </Form>
                </div>
                <div className="table-btn">
                  <Button
                    variant="primary"
                    onClick={toggleUserModal}
                  // onClick={() => navigate("/add-client")}
                  >
                    Add New
                  </Button>
                </div>
              </div>
              <div className="custom-table">
                {userLoading && <Spin />}
                <BootstrapTable
                  keyField="user_id"
                  remote
                  data={usersData}
                  columns={columns}
                  onTableChange={handleTableChange}
                  // expandRow={expandRow}
                  noDataIndication="No Data Found"
                />
                <Pagination
                  total={total}
                  limit={parseInt(limit)}
                  currentPage={page}
                  updateLimit={handleUpdateLimit}
                  updatePage={handleChangePage}
                  from={from}
                  to={to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showUser && (
        <AddUser
          toggleUserModal={toggleUserModal}
          userModal={userModal}
          showUser={showUser}
          clientId={clientId}
        />
      )}
    </>
  );
};

export default UsersForClient;
